module.exports = __webpack_public_path__ + "img/interface-2_en.03e113e.jpg";